module.exports = __webpack_public_path__ + "img/cars-paris-mobile.1689f74b.png";